// extracted by mini-css-extract-plugin
module.exports = {"root":"editor-employee_root__32gP7"};